import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import imgAirtime from "assets/images/icons/call.svg";
import imgData from "assets/images/icons/data.svg";
import imgPower from "assets/images/icons/power.svg";
import imgTv from "assets/images/icons/tv.svg";
import sittingOnBench from "assets/images/bgs/SittingOnBench.png";
import Maybe from "components/__new/common/Maybe";
import useWallet from "hooks/useWallet";
import { ButtonLoader } from "components/__new/common/form";
import PageContent from "components/__new/common/PageContent";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";


export const BillPaymentOverview = () => {
    const { walletLoading, createWallet } = useWallet();
    const { dashboardLoading, dashboard } = useSelector((s) => s.entities.wallet);

    return (
        <div>

            <DynamicHeadTag
                headerText="Bill payment"
            />


            <Maybe condition={dashboardLoading === true}>
                <PageContent loading={dashboardLoading} />
            </Maybe>


            <Maybe condition={dashboardLoading === false && dashboard?.status === "success"}>
                <>
                    <div className="text-center max-w-sm mx-auto">
                        <div className="font-medium text-lg">
                            Welcome to Bill payment &nbsp;👋
                        </div>
                        <div className="mt-2 text-fade-dark">
                            You can make payment for any of our services <br className="hidden xl:block" /> from here with ease.
                        </div>
                    </div>

                    <div className="max-w-xl mx-auto mt-8 grid grid-cols-1 sm:grid-cols-2 gap-6 text-center">
                        <Product
                            link="/payments/bills/airtime"
                            image={imgAirtime}
                            title="Buy Airtime"
                            description="Click to buy for single user or more than one user"
                        />
                        <Product
                            link="/payments/bills/data"
                            image={imgData}
                            title="Buy Data"
                            description="Click to pay for your internet subscriptions"
                        />
                        <Product
                            link="/payments/bills/power"
                            image={imgPower}
                            title="Buy Power"
                            description="Recharge your electricity credit for more light"
                        />
                        <Product
                            link="/payments/bills/tv"
                            image={imgTv}
                            title="Pay TV"
                            description={<>Pay for your cable <br className="hidden xl:block" /> subscriptions</>}
                        />
                    </div>
                </>
            </Maybe>


            <Maybe condition={dashboardLoading === false && (dashboard?.status === undefined || dashboard?.status === "failed")}>
                <div className="min-h-[500px] flex justify-center items-center">
                    <div className="max-w-lg py-14">
                        <div className="h-48 flex">
                            <img src={sittingOnBench} alt="empty" className="max-w-full max-h-full m-auto object-contain" />
                        </div>

                        <div className="text-center mt-8">
                            <div className="font-semibold text-lg">
                                Sorry, you do not have a wallet yet.
                            </div>
                            <div className="text-fade mt-0.5">
                                Please click the button below to create your wallet in few seconds.
                            </div>
                            <div className="mt-8 flex justify-center">
                                <ButtonLoader type="button" loading={walletLoading} className="btn btn-ep-primary" onClick={createWallet}>
                                    Create Wallet
                                </ButtonLoader>
                            </div>
                        </div>
                    </div>
                </div>
            </Maybe>


        </div>
    )
}


const Product = (props) => {
    return (
        <Link to={props.link} className="box">
            <div>
                <img src={props.image} alt="airtime" className="w-16 h-16 mx-auto" />
            </div>
            <div className="mt-6">
                <div className="font-medium text-lg">
                    {props.title}
                </div>
                <div className="text-fade-dark mt-2">
                    {props.description}
                </div>
            </div>
        </Link>
    )
}


export default BillPaymentOverview;